/**
 * Created by pwq on 2016/12/7.
 */

import {
    REQUEST_QUESTIONS,
    RECEIVE_QUESTIONS,
    SET_KEY_VALUE,
    RESET_SEARCH_STATUS,
    RECEIVE_INTERVIEW_AREAS
} from './actions';


const initFilter = {
    categoryId: [''],
    page: 1,
    pageSize: 10,
    province: '',
    query: '',
    questionTag: '',
    title: '',
    year: '',
    areas: [],                       //面试地区列表
};

export function interviewList(state = {
    isFetching: true,
    items: [],
    ...initFilter
}, action) {
    switch (action.type) {
        case REQUEST_QUESTIONS:
            return Object.assign({}, state, {isFetching: true});
        case RECEIVE_QUESTIONS:
            return Object.assign({}, state, {
                isFetching: false,
                items: action.questionList,
                totalPages: action.totalPages,
                totalElements: action.totalElements,
                lastUpdated: action.receivedAt
            });
        case SET_KEY_VALUE:
            return Object.assign({}, state, { [action.key]: action.value });
        case RESET_SEARCH_STATUS:
            return Object.assign({}, state, {...initFilter});
        case RECEIVE_INTERVIEW_AREAS:
            return Object.assign({}, state, {areas: action.areas});
        default:
            return state;
    }
}
